import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';

import { receiveError, receiveSuccess } from '../../../../store/actions/notificationAction';
import { triggerUpdate } from '../../../../store/actions/managedExportRightSideAction';
import { entryAddClearData, entryEditAddData, entryEditClearData } from '../../../../store/actions/manualEntryEditAction';

import pickupOrderRemote from '../../../../api/pickupOrderRemote';

import ghaOrdersListStyles from './ghaOrdersList.module.css';
import commonStyles from '../../../common/common.module.css';

import GhaOrdersList from './GhaOrdersList';
import ManualEntryModalContainer from '../manualEntry/ManualEntryModalContainer';
import DriverInfoAndTruckCoUpdateModalContainer from '../../../common/driverInfoAndTruckCoUpdate/DriverInfoAndTruckCoUpdateModalContainer';

import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import OrderDashboard from '../../../../models/OrderDashboard';
import DriverTruckEdit from '../../../../models/DriverTruckEdit';
import ManualEntryEdit from '../../../../models/ManualEntryEdit';
import OrderSearchOptions from '../../../../models/OrderSearchOptions';

import environments from '../../../../configs/environments';
import { SEARCH_OPTIONS_SCHEMA } from '../../../../utils/searchOptions';;

import moment, { Moment } from 'moment';
import { UserRoleType } from '../../../../models/User';
import PickupOrderFwd from '../../../../models/PickupOrderFwd';
import OrderNumberSearch from '../../../common/OrderNumberSearch';
import OrderAttachmentsContainer from '../../../orderAttachments/OrderAttachmentsContainer';
import { baseUrl } from '../../../../api/baseUrl';
import { setAwbAction } from '../../../../store/actions/selectAwbAction';
import SuspendOrderConfirm from '../../../common/SuspendOrderConfirm';

interface GhaOrdersListContainerProps {
  type: string;
  receiveError: Function;
  receiveSuccess: (message: string) => void;
  selectedPoNumber: string;
  handleChange: (number: string) => void;
  selectFirstPickupOrder: (poNumber: string) => void;
  searchOptions: OrderSearchOptions;
  triggerManagedExportRightSideContainerUpdate: () => void;
  history: History;
  entryEditAddData: (manualEntryData: ManualEntryEdit) => void;
  entryEditClearData: () => void;
  entryAddClearData: () => void;
  startDate: Moment;
  endDate: Moment;
  startTime: string;
  endTime: string;
  currDate: boolean;
  handleClick: () => void;
  disabledDate: () => void;
  changeFocuses: () => void;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeTime: (timeType: string, event: any) => void;
  search: () => void;
  keyword: string;
  errorKeyword: boolean;
  handleChangeKeyword: (event: any) => void;
  setAwbAction: (number: string, changed: boolean) => void;
};

interface GhaOrdersListContainerState {
  pos: Array<OrderDashboard>;
  searchOptions: OrderSearchOptions;
  openDriverTruckCompanyModal: boolean;
  selectedDrvTrkData: DriverTruckEdit;
  orderType: string;
  openModalManualEntry: boolean;
  poList: Array<PickupOrderFwd>;
  startDate: Moment;
  endDate: Moment;
  startTime: string;
  endTime: string;
  keyword: string;
  currDate: boolean;
  errorKeyword: boolean;
  completed: boolean;
  suspended: boolean;
  progressBar: boolean;
  isOrderAttachmentsDialogOpen: boolean;
  attachmentOrderNumber: OrderDashboard;
  orderNumber: string;
  suspendOrder: boolean;
  suspensionType: string;
  suspensionReason: string;
  suspensionError: string;
};

class GhaOrdersListContainer extends Component<GhaOrdersListContainerProps, GhaOrdersListContainerState> {

  intervalID: number | undefined;
  
  orderConn: any;

  state = {
    pos: [],
    searchOptions: SEARCH_OPTIONS_SCHEMA,
    openDriverTruckCompanyModal: false,
    selectedDrvTrkData: {
      orderNumber: '',
      delivery_company_name: '',
      delivery_company_name_new: '',
      driver_id: '',
      driver_id_type: '',
      driver_name: '',
      driver_vehichle_registration: '',
      rfs_number: ''
    },
    orderType: '',
    openModalManualEntry: false,
    poList: [],
    startDate: moment(),
    endDate: moment(),
    startTime: '',
    endTime: '',
    keyword: '',
    completed: true,
    suspended: false,
    currDate: false,
    errorKeyword: false,
    progressBar: false,
    isOrderAttachmentsDialogOpen: false,
    attachmentOrderNumber: {} as OrderDashboard,
    orderNumber: '',
    suspendOrder: false,
    suspensionType: '',
    suspensionReason: '',
    suspensionError: ''
  }

  componentDidMount() {

    this.doGetOrdersRequest(true, false);
    const currState: GhaOrdersListContainerState = { ...this.state };
    const startDate: string = currState.startDate.format('YYYYMMDD');
    const endDate: string = currState.endDate.format('YYYYMMDD');
    this.ordersRequest(startDate, endDate, currState.startTime, currState.endTime, currState.keyword, true);
    this.setState({ orderType: this.props.type });
  }

  componentDidUpdate(prevProps: GhaOrdersListContainerProps) {

    if (this.props.searchOptions !== prevProps.searchOptions) {
      this.setState({ searchOptions: { ...this.props.searchOptions } }, () => {
        this.doGetOrdersRequest(true, true);
      });
    }

    if (this.props.type !== prevProps.type) {
      this.subscribeToOrders()
      this.setState({ searchOptions: SEARCH_OPTIONS_SCHEMA, orderType: this.props.type }, () => {
        this.doGetOrdersRequest(true, true);
      });
    }
    const currentDate: string = moment().format('YYYYMMDD');

    if (prevProps.type !== this.props.type) {
      this.setState({
        poList: [],
        startDate: moment(),
        endDate: moment(),
        startTime: '',
        endTime: '',
        keyword: '',
        currDate: false,
        errorKeyword: false
      });
      this.ordersRequest(currentDate, currentDate, '', '', '', true);
    }
  }

  componentWillUnmount() {
    this.closeConnection();
  }

  printOrderInfoClicked = (orderNumber: string) => {

    let url: string = `${baseUrl}pickup_order/${orderNumber}/file?type=receipt`;

    window.open(url);
  }

  closeConnection = () => {
    this.orderConn.close();
  }

  handleSuspendOrder = () => {
    if (this.state.suspensionReason.trim() === "") {
      this.setState({ suspensionError: "Suspension reason is required." });
    } else {
      this.setState({ suspensionError: "" });
      this.suspendOrder();
    }
  };

  subscribeToOrders() {
   this.orderConn = new EventSource(baseUrl + `orders?type=${this.props.type}`, {
      withCredentials: true
    });
    this.orderConn.onmessage = (event: any) => {
      
      const data: any = JSON.parse(event.data);
      if (data) {
        const order: OrderDashboard = data.order;
        if(order.isRfs) {
          order.number_type = `${order.number} (R)`;
        } else if(order.isInterline) {
          order.number_type = `${order.number} (I)`;
        } else {
          order.number_type = order.number;
        }
        if(order.return_type) {
          order.number_type = `${order.number} (Ret)`;
        }
        if (order.was_go === 'true' || order.was_go === true || order.parent_go_id) {
          order.number_type += ' (GO)';
        }
        let pos: Array<OrderDashboard> = [...this.state.pos];
        if(data.eventType == 'color') {
          let obj = pos.find((o: OrderDashboard, i: number) => {
            if (o.number === order.number) {
              pos[i] = order;
              return true; // stop searching
            }
          });
        } else if(data.eventType == 'delete') {
          pos = pos.filter((po: OrderDashboard) => po.number !== order.number);
          this.props.handleChange('-1');

        } else {
          const startDate: string = this.props.startDate.format('YYYYMMDD');
          const endDate: string = this.props.endDate.format('YYYYMMDD');
          if(order.pickup_date >= startDate && order.pickup_date <= endDate) {
            pos.push(order);
          }
        }
    
        this.setState({ pos });
      }

    }

    this.orderConn.onerror = (error: any) => {

      if (error.type === 'error') {

        // dispatch(receiveError(error));

      }

    }
  }

  ordersRequest = (startDate: string, endDate: string, startTime: string, endTime: string, keyword: string, doSort: boolean): void => {
    
    pickupOrderRemote.getPickupOrdersFwd(this.props.type, startDate, endDate, startTime, endTime, keyword, doSort).then((resp: ApiResponse<Array<PickupOrderFwd>>) => {
      const poList: Array<PickupOrderFwd> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (poList) {
        this.setState({ poList });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  doGetOrdersRequest = (doSort: boolean, progress: boolean): void => {

    const orderType: string = this.state.orderType;
    let searchOptions: OrderSearchOptions = { ...this.state.searchOptions };
    let startDate: string = searchOptions.startDate.format('YYYYMMDD');
    let endDate: string = searchOptions.endDate.format('YYYYMMDD');
    let startTime: string = searchOptions.startTime;
    let endTime: string = searchOptions.endTime;

    if (searchOptions.ignoreDateAndTime && searchOptions.ignoreDateAndTime === true) {
      startDate = '';
      endDate = '';
      startTime = '';
      endTime = '';
    }
    this.setState({ progressBar: progress }, () => {
      if (orderType) {

        pickupOrderRemote.getPickupOrdersGha(orderType, startDate, endDate, startTime, endTime, searchOptions.keyword, doSort, this.state.completed, this.state.suspended).then((resp: ApiResponse<Array<OrderDashboard>>) => {
  
          const pos: Array<OrderDashboard> | undefined = resp.result;
          const error: ResponseError | undefined = resp.error;
  
          if (pos) {
            pos.forEach((po: OrderDashboard) => {
              if(po.isRfs) {
                po.number_type = `${po.number} (R)`;
              } else if(po.isInterline) {
                po.number_type = `${po.number} (I)`;
              } else {
                po.number_type = po.number;
              }
              if(po.return_type) {
                po.number_type = `${po.number} (Ret)`;
              }
              if (po.was_go === 'true' || po.was_go === true || po.parent_go_id) {
                po.number_type += ' (GO)';
              }
            });
            this.setState({ pos}, () => {
             
            });
  
            let poNumb: boolean = pos.some(po => po.number === this.props.selectedPoNumber )
  
            if (pos.length > 0 && (!this.props.selectedPoNumber || this.props.selectedPoNumber === '-1' || !poNumb)) {
              this.props.selectFirstPickupOrder(pos[0].number);
            } else if(pos.length <= 0) {
              this.props.selectFirstPickupOrder('-1');
            }
          }
  
          if (error) {
            this.props.receiveError(error);
          } if(searchOptions.keyword.split('-').length > 1) {
            this.props.setAwbAction(searchOptions.keyword, true);
            setTimeout(() => {
              this.props.setAwbAction('', false);
            }, 4000);
          }
          this.setState({ progressBar: false });
        });
      } else {
        this.setState({ progressBar: false });
      }
    })

  }

  handleOpenManualEntryOrDrvTrkEdit = (data: OrderDashboard): void => {

    if (data.isManualEntry !== undefined && data.isManualEntry === true) {

      this.handleOpenManualEntryEdit(data);

    } else {

      this.handleOpenDrvTrkEdit(data);
    }
  }

  showOrders = (type: string): void => {
    const poList = [...this.state.pos];
    let filteredList;
  
    if (type === 'completed') {
      filteredList = poList.filter((po: PickupOrderFwd) => {
        if (po.truck_status.fully_delivered) {
          return po.truck_status.fully_delivered === !this.state.completed;
        } else {
          return po;
        }
      });
      this.setState({ pos: filteredList, completed: !this.state.completed });
    } else if (type === 'suspended') {
      filteredList = poList.filter((po: PickupOrderFwd) => {
        if (po.suspended) {
          return po.suspended === !this.state.suspended;
        } else {
          return po;
        }
      });
      this.setState({ pos: filteredList, suspended: !this.state.suspended });
    }
  
    this.doGetOrdersRequest(true, true);
  }

  handleOpenManualEntryEdit = (data: OrderDashboard): void => {

    const manualEntryEditData: ManualEntryEdit = {
      isEditMode: true,
      driverData: {
        driverId: data.driver_id || '',
        driverIdType: data.driver_id_type || '',
        name: data.driver_name || '',
        company: data.delivery_company_name || '',
        truckPlateNumber: data.driver_vehichle_registration || '',
        driverTime: data.driver_checkin_time,
        rfsNumber: data.rfs_number || ''
      },
      forwarderId: data.id_forwarder,
      dockId: data.dock_id,
      orderNumber: data.number,
      orderId: data.id,
      isInterline: data.isInterline,
      isRfs: data.isRfs
    };

    this.setState({ openModalManualEntry: true });
    this.props.entryEditAddData(manualEntryEditData);
  }

  closeOrderAttachments = (): void => {

    this.setState({ isOrderAttachmentsDialogOpen: false });
  };

  openAttachments = (order: OrderDashboard): void => {

    this.setState({ isOrderAttachmentsDialogOpen: true, attachmentOrderNumber: order });
  };

  handleOpenDrvTrkEdit = (data: OrderDashboard): void => {

    const selectedDrvTrkData: DriverTruckEdit = {
      orderNumber: data.number,
      delivery_company_name: data.delivery_company_name || '',
      delivery_company_name_new: data.delivery_company_name || '',
      driver_id: data.driver_id || '',
      driver_id_type: data.driver_id_type || '',
      driver_name: data.driver_name || '',
      driver_vehichle_registration: data.driver_vehichle_registration || '',
      rfs_number: data.rfs_number || ''
    };

    this.setState({ selectedDrvTrkData, openDriverTruckCompanyModal: true });
  }

  handleCloseDrvTrkEdit = (updated?: boolean): void => {

    this.setState({
      openDriverTruckCompanyModal: false},
      () => {
        updated && typeof updated === 'boolean' ? this.props.receiveSuccess('Trucker and driver\'s information been successfully updated!') : {};
        this.props.triggerManagedExportRightSideContainerUpdate();
      });
  }

  handleCloseModalManualEntry = (isUpdated?: boolean, cancel?: boolean): void => { 
    if(cancel === false) {
      this.props.entryEditClearData();
    }
    this.props.entryAddClearData();
    this.setState({ openModalManualEntry: false }); 
    this.doGetOrdersRequest(true, true);
    this.handleCloseDrvTrkEdit(isUpdated);
  }

  linkPoDetails = (poNumber: string): void => {
    if (this.props.type === 'po') {
      this.props.history.push(`/po/${poNumber}`);
    }

    if (this.props.type === 'do') {
      this.props.history.push(`/do/${poNumber}`);
    }
  };

  onChange = (event: any): void => {
    const value = event.target.value;
    this.setState({ suspensionReason: value });
  }

  suspendOrder = (): void => {
    const order = this.state.attachmentOrderNumber;
    const data = {
      type: order.suspended ? 'unsuspend' : 'suspend',
      reason: this.state.suspensionReason
    };
    pickupOrderRemote.suspendOrder(order.number, data).then((resp: ApiResponse<boolean>) => {
      const result: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({ suspendOrder: false, suspensionReason: '' });
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  openModal = (type: string, order: OrderDashboard): void => {
    this.setState({ suspendOrder: true, attachmentOrderNumber: order, suspensionType: type });
  }

  closeModal = (): void => {
    this.setState({ suspendOrder: false });

  }

  disabledDate = (): void => {
    this.setState({ currDate: true });
  };

  render() {
    return (
      <Fragment>
        <div className={ `${ commonStyles.wrapper } ${ ghaOrdersListStyles.wrapper }` }>
          <h3 className={commonStyles.header}>Orders</h3>
          <OrderNumberSearch
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            startTime={this.props.startTime}
            endTime={this.props.endTime}
            keyword={this.props.keyword}
            handleChangeDate={this.props.handleChangeDate}
            handleChangeTime={this.props.handleChangeTime}
            handleChangeKeyword={this.props.handleChangeKeyword}
            search={this.props.search}
            handleClick={this.props.handleClick}
            disabledDate={this.props.disabledDate}
            currDate={this.props.currDate}
            changeFocuses={this.props.changeFocuses}
            userRole={UserRoleType.FORWARDER}
            errorKeyword={ this.props.errorKeyword }
            completeOrders={ this.showOrders }
            completed={ this.state.completed }
            suspended={ this.state.suspended }
            progressBar={ this.state.progressBar }
            orderType={ this.state.orderType }
          />

          <GhaOrdersList
            ordersList={ this.state.pos }
            selectedOrderNumber={ this.props.selectedPoNumber }
            handleChange={ this.props.handleChange }
            openDrvTrkEdit={ this.handleOpenManualEntryOrDrvTrkEdit }
            openAttachments={ this.openAttachments }
            printOrderInfoClicked={ this.printOrderInfoClicked }
            openModal={ this.openModal }
          />

          { this.state.openDriverTruckCompanyModal &&
            <DriverInfoAndTruckCoUpdateModalContainer
              modalOpen={this.state.openDriverTruckCompanyModal}
              selectedDrvTrkData={this.state.selectedDrvTrkData}
              handleClose={this.handleCloseDrvTrkEdit}
            />
          }

          { this.state.suspendOrder &&
            <SuspendOrderConfirm
              modalOpen={this.state.suspendOrder}
              handleClose={this.closeModal}
              suspensionReason={ this.state.suspensionReason }
              onChange={ this.onChange }
              suspendOrder={ this.handleSuspendOrder }
              type={ this.state.suspensionType }
              error={ this.state.suspensionError }
            />
          }

          { this.state.openModalManualEntry &&
            <ManualEntryModalContainer
              type={this.state.orderType}
              history={this.props.history}
              modalOpen={this.state.openModalManualEntry}
              handleCloseModal={this.handleCloseModalManualEntry}
              driverData={{
                name: this.state.selectedDrvTrkData.driver_name,
                company: this.state.selectedDrvTrkData.delivery_company_name,
                check_in: null
              }}
            />
          }
          { this.state.isOrderAttachmentsDialogOpen && 
            <OrderAttachmentsContainer
              orderId={ this.state.attachmentOrderNumber.id }
              number={ this.state.attachmentOrderNumber.number }
              process={ "export" }
              closeAttachments={ this.closeOrderAttachments }
              refreshAwbs={ true }
              type={ 'orders' }
            />
          }
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message)),
    triggerManagedExportRightSideContainerUpdate: () => dispatch(triggerUpdate()),
    entryEditAddData: (manualEntryData: ManualEntryEdit) => dispatch(entryEditAddData(manualEntryData)),
    entryEditClearData: () => dispatch(entryEditClearData()),
    entryAddClearData: () => dispatch(entryAddClearData()),
    setAwbAction: (awbNumber: string, changed: boolean) => dispatch(setAwbAction(awbNumber, changed))
  };
};

export default connect(null, mapDispatchToProps)(GhaOrdersListContainer);
